/**
 * Children's Health frontend module — shared API helpers + age palette.
 * Keeps each page focused on rendering, not transport.
 */
import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/children`;

const cfg = { withCredentials: true };

export const api = {
  snapshot:        () => axios.get(`${API}/snapshot`, cfg).then((r) => r.data),
  getProfile:      () => axios.get(`${API}/profile`, cfg).then((r) => r.data),
  saveProfile:     (data) => axios.post(`${API}/profile`, data, cfg).then((r) => r.data),
  postCheckin:     (data) => axios.post(`${API}/checkin`, data, cfg).then((r) => r.data),
  recentCheckins:  () => axios.get(`${API}/checkins/recent`, cfg).then((r) => r.data),
  postGrowth:      (data) => axios.post(`${API}/growth`, data, cfg).then((r) => r.data),
  recentGrowth:    () => axios.get(`${API}/growth/recent`, cfg).then((r) => r.data),
  vaccines:        () => axios.get(`${API}/vaccines`, cfg).then((r) => r.data),
  markVaccine:     (data) => axios.post(`${API}/vaccines/mark`, data, cfg).then((r) => r.data),
  postMeal:        (data) => axios.post(`${API}/meals`, data, cfg).then((r) => r.data),
  nutritionInsights: () => axios.get(`${API}/nutrition/insights`, cfg).then((r) => r.data),
  postBehaviour:   (data) => axios.post(`${API}/behaviour`, data, cfg).then((r) => r.data),
  behaviourInsights: () => axios.get(`${API}/behaviour/insights`, cfg).then((r) => r.data),
  quickCheck:      (data) => axios.post(`${API}/quick-check`, data, cfg).then((r) => r.data),
};

/** Friendly relative-time helper for "last check 2h ago" copy. */
export function relativeTime(iso) {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return 'just now';
  const mins = Math.floor(ms / 60_000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks}w ago`;
  return `${Math.floor(days / 30)}mo ago`;
}

/** Status → tailwind palette token map. */
export const STATUS_PALETTE = {
  'On track':         { text: 'text-emerald-700', bg: 'bg-emerald-50',  border: 'border-emerald-200', dot: 'bg-emerald-500' },
  'Stable':           { text: 'text-emerald-700', bg: 'bg-emerald-50',  border: 'border-emerald-200', dot: 'bg-emerald-500' },
  'Monitor':          { text: 'text-amber-700',   bg: 'bg-amber-50',    border: 'border-amber-200',   dot: 'bg-amber-500' },
  'Needs attention':  { text: 'text-rose-700',    bg: 'bg-rose-50',     border: 'border-rose-200',    dot: 'bg-rose-500' },
  'Not checked yet':  { text: 'text-gray-700',    bg: 'bg-gray-50',     border: 'border-gray-200',    dot: 'bg-gray-400' },
};
